import Typeahead from 'components/inputs/typeahead';
import { QuoteRecipientsType } from 'data/types';

type QuoteRecipientFieldsProps = {
  emailOptions: string[];
  phoneNumberOptions: string[];
  draft: QuoteRecipientsType;
  error: string | null;
  onEmailChange: (email: string) => void;
  onPhoneNumberChange: (phoneNumber: string) => void;
  onEmailInputChange: (email: string) => void;
  onPhoneNumberInputChange: (phoneNumber: string) => void;
};

export default function QuoteRecipientFields({
  emailOptions,
  phoneNumberOptions,
  draft,
  error,
  onEmailChange,
  onPhoneNumberChange,
  onEmailInputChange,
  onPhoneNumberInputChange
}: QuoteRecipientFieldsProps) {
  return (
    <div className='flex flex-col gap-4'>
      <p className='text-sm text-gray-600'>
        Enter an email address, a mobile number, or both.
      </p>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-semibold text-gray-700'>Email</span>
        <Typeahead
          placeholder='example@domain.com'
          options={emailOptions}
          inputValue={draft.email}
          onInputChange={onEmailInputChange}
          onChange={(value) => onEmailChange(value.toString())}
          customOptionFormat={(input) => `New Email: ${input}`}
          allowCustom
        />
      </div>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-semibold text-gray-700'>
          Mobile number
        </span>
        <Typeahead
          placeholder='(123) 456-7890'
          options={phoneNumberOptions}
          inputValue={draft.phoneNumber}
          onInputChange={onPhoneNumberInputChange}
          onChange={(value) => onPhoneNumberChange(value.toString())}
          customOptionFormat={(input) => `New Number: ${input}`}
          allowCustom
        />
      </div>
      {error && <div className='text-sm text-red-500'>{error}</div>}
    </div>
  );
}
